import Link from "next/link";

const ListItem = (props) => {
  const { children, action, link, url, value, className = "" } = props;
  return (
    <>
      {!link ? (
        <li
          value={value}
          onClick={action}
          //   className="text-sm text-gray-davys p-2 hover:bg-blue-magnolia hover:text-blue-hedgehog hover:rounded-lg"
          className={`text-sm  p-2 cursor-pointer ${className}`}
        >
          <div className="flex items-center">{children}</div>
        </li>
      ) : (
        <Link href={url}>
          <li className="text-sm text-gray-davys p-2 cursor-pointer flex whitespace-nowrap">
            <div className="flex items-center">{children}</div>
          </li>
        </Link>
      )}
    </>
  );
};

export default ListItem;
